import type { FaireProductEntity } from "../../entity_types/product";

export const p_t4vp5jn5v8: FaireProductEntity = {
  token: "p_t4vp5jn5v8",
  type: "product",
  name: "Dreamy Drop Squishy Viral Sensory Toy - Blue Dream",
  brandToken: "b_3jrwkg3xqx",
  brandName: "The Classy Cloth WS",
  imageUrl:
    "https://cdn.faire.com/fastly/34e8b1622a1967e6a45f31ebc4636f5c098c900828413b76b96891a0acff72f8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8f206006ea632ff35cb66cf121381f2433c4b20fdf686cca7b808ea723c0f376.jpeg",
  ],
  priceDollars: 4.5,
  description:
    "Tap into the viral squishy trend with these Dreamy Drop Squishies—an ultra-satisfying sensory toy customers can’t stop squeezing. Featuring a glossy, jelly-like texture with floating glitter details, each drop delivers a calming, addictive fidget experience perfect for all ages.\n\nDesigned to drive impulse purchases, this under $10 item is a must-have for checkout displays, kids sections, and giftable add-ons. A proven margin builder, these sensory drops are ideal for back to school, Easter baskets, stocking stuffers, and everyday gifting.\n\nWhy shops love it:\n\n• High sell-through impulse item\n\n• Trend-driven sensory toy category\n\n• Appeals to kids, tweens, teens & adults\n\n• Perfect for checkout displays & add-ons\n\nDetails:\n\n• Soft, squishy sensory stress toy\n\n• Glitter-filled, vibrant colors\n\n• Includes display stand (as shown)\n\n• Compact, lightweight, and giftable\n",
  tags: [],
  msrpDollars: 11.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:28.561Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
